import React, { useState, useEffect } from "react"
import "./signature-profiles-details.css"
import { RadioButton } from "@progress/kendo-react-inputs"
import { PlusBlue } from "../../../assets/logos/icons"
import { TreeView, processTreeViewItems } from '@progress/kendo-react-treeview'

import {
  PromotionalFooterPure,
  DialogTemplatePure,
  HeaderHLPure,
  InputHLPure,
  CheckBoxHLPure,
  TextAreaHLPure,
  ButtonHLPure,
  DialogSystemGLPure,
  DropDownBtnHLPure,
  ComboBoxTemplatePure
} from "../../pures"
import { Container, Grid, useMediaQuery } from "@material-ui/core"
import { DividerSubtitle } from "../../pures"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { SignatureProfileService, CompanyService, CategoryService } from "../../../services"
import { NIL, NIL as NIL_UUID } from 'uuid'

export default function SignatureProfilesDetailsView({
  token,
  id,
  icons,
  profile,
  userDocumentProfiles = []
}) {
  const url = process.env.REACT_APP_MIFIRMA_API;
  const signatureProfileService = new SignatureProfileService(url);
  const companyService = new CompanyService(url);
  const categoryService = new CategoryService(url);
  const ENV = process.env

  // const applicationIconsService = new ApplicationIconsService(url)

  const history = useHistory();
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [textError, setTextError] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogIcon, setShowDialogIcon] = useState(false);
  const toggleDialog = () => setShowDialog(!showDialog);
  const toggleDialogIcon = () => setShowDialogIcon(!showDialogIcon);

  const [name, setName] = useState(profile?.name || "");
  const [description, setDescription] = useState(profile?.description || "");
  const [requestName, setRequestName] = useState(profile?.defaultName || "");
  // const [resume, setResume] = useState(profile?.defaultDescription || "");
  const [comments, setComments] = useState(profile?.defaultComments || "");
  const [image, setImage] = useState(profile?.icon || null);
  const [processRandom, setprocessRandom] = useState(
    profile?.processRandom || false
  );
  const [processSequential, setprocessSequential] = useState(
    profile?.processSequential || false
  );
  const [processAprovation, setprocessAprovation] = useState(
    profile?.processAprovation || false
  );
  const [processAprovationSequential, setprocessAprovationSequential] =
    useState(profile?.processAprovationSequential || false);
  const [serviceConservationMessage, setserviceConservationMessage] = useState(
    profile?.serviceConservationMessage || false
  );
  const [serviceTimeStamp, setserviceTimeStamp] = useState(
    profile?.serviceTimeStamp || false
  );
  const [signatureTypeESign, setsignatureTypeESign] = useState(
    profile?.signatureTypeESign || false
  );
  const [signatureTypeAdvance, setsignatureTypeAdvance] = useState(
    profile?.signatureTypeAdvance || false
  );
  const [signatureTypeAutograph, setsignatureTypeAutograph] = useState(
    profile?.signatureTypeAutograph || false
  );
  const [documentProfile, setDocumentProfile] = useState({
    documentProfile: userDocumentProfiles,
  });

  const [days, setDays] = useState(profile?.numberDaysLimit || 0);
  const [uploadImage, setuploadImage] = useState(null);
  const [showBtnSave, setShowBtnSave] = useState(true)
  const [proofOfLifeChecked, setProofOfLifeChecked] = useState(profile?.proofOfLife || false)
  const [biometricId, setBiometricId] = useState('')
  const [pscSelected, setPSCSelected] = useState((profile?.serviceConservationMessage || profile?.serviceTimeStamp) ? (profile?.serviceConservationMessage) ? t("signatureProfilesDetailsView.messagePreservation") : t("signatureProfilesDetailsView.digitalTime") : '')
  const [companies, setCompanies] = useState([{ companyName: t("signatureProfilesDetailsView.digitalVault.withoutAssign"), id: NIL_UUID }])
  const [categories, setCategories] = useState([{ id: 0, name: t("signatureProfilesDetailsView.digitalVault.withoutAssign") }])
  const [subCategories, setSubCategories] = useState({ items: [], subcategory: {} })
  const [typeDocuments, setTypeDocuments] = useState([])
  const [allTypeDocuments, setAllTypeDocuments] = useState([])

  const [companyId, setCompanyId] = useState(NIL_UUID)
  const [categoryId, setCategoryId] = useState(0)
  const [typeDocument, setTypeDocument] = useState('')
  const [select, setSelect] = useState([""]);
  const [showErrorCompany, setShowErrorCompany] = useState(false)
  const [showErrorCategories, setShowErrorCategories] = useState(false)
  const [showErrorSub, setShowErrorSub] = useState(false)
  const [showErrorTypeDoc, setShowTypeDoc] = useState(false)
  const [showErrorComboBox, setShowComboBox] = useState(false)
  const [expand, setExpand] = useState({
    ids: [],
    idField: "subcategory.id",
  });
  const isMobile = useMediaQuery("(max-width: 880px)")
  const is560 = useMediaQuery("(max-width: 560px)")

  useEffect(() => {
    getCompanies()
    getTypeDocuments()
  }, [])

  useEffect(() => {
    if (!profile) return
    let showBtn = !profile.defaultSignatureProfile
    let biometricId = ''
    if (profile.proofOfLife || profile.faceRecognition) biometricId = (profile.proofOfLife) ? 'proofOfLife' : 'faceRecognition'
    setShowBtnSave(showBtn)
    setBiometricId(biometricId)

    let companyId = (profile && profile.classifierCategory && profile.classifierCategory.companyId && profile.classifierCategory.companyId !== NIL) ? profile.classifierCategory.companyId : NIL
    let categoryId = (profile && profile.classifierCategory && profile.classifierCategory.categoryId) ? profile.classifierCategory.categoryId : 0
    let pathBreadcrumb = (profile && profile.classifierCategory && profile.classifierCategory.pathBreadcrumb) ? profile.classifierCategory.pathBreadcrumb : 0
    if (companyId) {
      getCategoriesPreloaded(companyId, categoryId)
    }

    if (companyId && categoryId) {
      getSubcategoriesPreloaded(companyId, categoryId, pathBreadcrumb)
    }
  }, [profile])

  useEffect(() => {
    if (!profile || !profile.classifierCategory || !profile.classifierCategory.typeDocumentId || allTypeDocuments.length === 0) return
    let typeDocument = allTypeDocuments.find(type => type.id === profile.classifierCategory.typeDocumentId)

    if (typeDocument) {
      setTypeDocument(typeDocument)
    }
  }, [profile, allTypeDocuments])

  useEffect(() => {
    if (!profile || !profile.classifierCategory || !profile.classifierCategory.companyId || profile.classifierCategory.companyId === NIL || companies.length === 0) return
    let copmany = companies.find(company => company.id === profile.classifierCategory.companyId)
    if (copmany) {
      setCompanyId(copmany.id)
    }
  }, [profile, companies])

  useEffect(() => {
    handleChangeTypeDocument()
  }, [allTypeDocuments, serviceConservationMessage, documentProfile.documentProfile, typeDocument])

  const handleChangeTypeDocument = (e) => {
    if (allTypeDocuments.length === 0 || !documentProfile) return
    const profileDocumentsSelected = documentProfile.documentProfile.filter(item => { return item.checked })
    let infoTypeString = ENV.REACT_APP_DIGITAL_VAULT_DOCUMENT
    if (serviceConservationMessage || profileDocumentsSelected.length > 1) infoTypeString = ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE
    const typeDocumentsFiltered = allTypeDocuments.filter(td => { return td.infoType === infoTypeString })
    if (typeDocument && typeDocument.infoType && infoTypeString !== typeDocument.infoType) {
      setTypeDocument('')
    }
    setTypeDocuments(typeDocumentsFiltered)
  }

  const deleteSigatureProfiles = () =>
    signatureProfileService.deleteSigatureProfiles(token, id);

  //save icon
  const onSaveImg = () => {
    toggleDialogIcon();
    setuploadImage(image);
  };

  const onChangeUserDocumentProfile = (checked, index) => {
    const copyUser = [...documentProfile.documentProfile]
    copyUser[index] = {
      ...copyUser[index],
      checked,
    }
    setDocumentProfile({ ...documentProfile, documentProfile: copyUser })
  }

  const fetch = async () => {
    let types =
      signatureTypeESign || signatureTypeAdvance || signatureTypeAutograph;
    let ordens =
      processRandom ||
      processSequential ||
      processAprovation ||
      processAprovationSequential;

    let filteredDocument = {};
    filteredDocument.documentProfile = documentProfile.documentProfile.filter(
      (item) => item.checked
    );

    if (name && description && ordens && types && image) {
      setIsLoading(true);
      setShowDialog(true)

      let pathBreadcrumb = ''
      let subCategoryId = 0
      if (companyId && companyId !== NIL_UUID && categoryId && categoryId > 0 && select[0] && select[0] !== '') {
        let subSplit = select[0].split('_')

        if (subSplit && subSplit.length === 1) {
          let subcategory = subCategories[select[0]]
          subCategoryId = subcategory.subcategory.id
          pathBreadcrumb = `${subcategory.subcategory.id}`
        }

        if (subSplit && subSplit.length === 2) {
          let catIndex = (subSplit) ? subSplit[0] : 0
          let subIndex = (subSplit) ? subSplit[1] : 1
          let catFind = subCategories[catIndex]
          let subcategoryFind = catFind.items[subIndex]
          subCategoryId = subcategoryFind.subcategory.id
          pathBreadcrumb = `${catFind.subcategory.id}/${subCategoryId}`
        }

        if (subSplit && subSplit.length === 3) {
          let catIndex = (subSplit) ? subSplit[0] : 0
          let subIndex = (subSplit) ? subSplit[1] : 0
          let subSubIndex = (subSplit) ? subSplit[2] : 0
          let catFind = subCategories[catIndex]
          let subcategoryFind = catFind.items[subIndex]
          let subSubFind = subcategoryFind.items[subSubIndex]
          subCategoryId = subSubFind.subcategory.id
          pathBreadcrumb = `${catFind.subcategory.id}/${subcategoryFind.subcategory.id}/${subCategoryId}`
        }
      }

      let dataClassifier = {
        companyId,
        categoryId,
        subCategoryId,
        pathBreadcrumb,
        typeDocument
      }

      if (id) {
        let data = {
          id,
          name,
          description,
          icon: image,
          numberDaysLimit: days,
          defaultName: requestName,
          // defaultDescription: resume,
          defaultComments: comments,
          processRandom,
          processSequential,
          processAprovation,
          processAprovationSequential,
          serviceConservationMessage,
          serviceTimeStamp,
          signatureTypeESign,
          signatureTypeAdvance,
          signatureTypeAutograph,
          documentProfile: filteredDocument,
          proofOfLife: proofOfLifeChecked,
          dataClassifier
        };
        // if (uploadImage) data.icon = uploadImage;
        await signatureProfileService
          .changeSigatureProfiles(token, data)
          .then((res) => {
            if (res.statusCode < 1) throw new Error(res.message);
            setSuccess(true);
            setIsLoading(false);
            setTimeout(() => {
              history.push({
                pathname: `/signature-profile`,
              });
            }, 2000);
          })
          .catch((err) => {
            setError(true);
            setTextError(err.message);
            setIsLoading(false);
            toggleDialog();
          });
      } else {
        let data = {
          microserviceId: 2,
          name,
          description,
          icon: image,
          numberDaysLimit: days,
          defaultName: requestName,
          // defaultDescription: resume,
          defaultComments: comments,
          processRandom,
          processSequential,
          processAprovation,
          processAprovationSequential,
          serviceConservationMessage,
          serviceTimeStamp,
          signatureTypeESign,
          signatureTypeAdvance,
          signatureTypeAutograph,
          documentProfile: filteredDocument,
          proofOfLife: proofOfLifeChecked,
          dataClassifier
        };
        // if (uploadImage) data.icon = uploadImage;
        await signatureProfileService
          .createSigatureProfiles(token, data)
          .then((res) => {
            if (res.statusCode < 1) throw new Error(res.message);
            setSuccess(true);
            setIsLoading(false);
            setTimeout(() => {
              history.push({
                pathname: `/signature-profile`,
              });
            }, 2000);
          })
          .catch((err) => {
            setError(true);
            setTextError(err.message);
            setIsLoading(false);
            toggleDialog();
          });
      }
    } else {
      let messageError = t("signatureProfilesDetailsView.errors.add.image")
      if (!types) messageError = t("signatureProfilesDetailsView.errors.add.type")
      if (!ordens) messageError = t("signatureProfilesDetailsView.errors.add.order")
      if (!description) messageError = t("signatureProfilesDetailsView.errors.add.description")
      if (!name) messageError = t("signatureProfilesDetailsView.errors.add.name")
      setError(true);
      setTextError(messageError);
      setIsLoading(false);
      setTimeout(() => {
        setError(false)
      }, 3000)
    }
  };

  //Delete icon, cancel btn
  const onCancelIcon = () => {
    toggleDialogIcon();
    setImage(null);
    setuploadImage(null);
  };

  const handleChangeAutographCheck = (e) => {
    setsignatureTypeAutograph(e.target.checked)
    if (signatureTypeAutograph) {
      setProofOfLifeChecked(false)
      setBiometricId('')
    }
  }

  const handleChangeBiometric = (e, id) => {
    let proofOfLife = (id === 'proofOfLife') ? true : false
    let biometric = id

    if (biometricId && id && id === biometricId) {
      proofOfLife = false
      biometric = ''
    }

    setProofOfLifeChecked(proofOfLife)
    setBiometricId(biometric)
  }

  const handleSelectPSC = (e, service) => {
    let value = e.target.checked
    let conservationMessage = false
    let timeStamp = false
    let psc = ''

    if (!pscSelected && !value && service === pscSelected) {
      conservationMessage = false
      timeStamp = false
      psc = ''
    } else if (pscSelected && !value && service === pscSelected) {
      conservationMessage = false
      timeStamp = false
      psc = ''
    } else if (!pscSelected && !value && service === t("signatureProfilesDetailsView.messagePreservation")) {
      conservationMessage = true
      psc = t("signatureProfilesDetailsView.messagePreservation")
    } else if (!pscSelected && !value && service === t("signatureProfilesDetailsView.digitalTime")) {
      timeStamp = true
      psc = t("signatureProfilesDetailsView.digitalTime")
    } else if (pscSelected !== service && value && service === t("signatureProfilesDetailsView.messagePreservation")) {
      conservationMessage = true
      psc = t("signatureProfilesDetailsView.messagePreservation")
    } else if (pscSelected !== service && !value && service === t("signatureProfilesDetailsView.messagePreservation")) {
      timeStamp = true
      psc = t("signatureProfilesDetailsView.digitalTime")
    } else if (pscSelected !== service && value && service === t("signatureProfilesDetailsView.digitalTime")) {
      timeStamp = true
      psc = t("signatureProfilesDetailsView.digitalTime")
    } else if (pscSelected !== service && !value && service === t("signatureProfilesDetailsView.digitalTime")) {
      conservationMessage = true
      psc = t("signatureProfilesDetailsView.messagePreservation")
    }

    setserviceConservationMessage(conservationMessage)
    setserviceTimeStamp(timeStamp)
    setPSCSelected(psc)
  }

  const handleChange = (e, setValue, type, setShowError, typeSelect) => {
    let value = e.target.value
    if (type === 'Number') value = Number(value)
    if (setShowError) setShowError(false)
    setValue(value)

    if (typeSelect === 'company') {
      getCategories(value, setCategoryId, setSelect)
    }

    if (typeSelect === 'category') {
      getSubcategories(companyId, value, setSelect)
    }
  }

  const getCompanies = async () => {
    setIsLoading(true);
    toggleDialog();
    try {
      let companiesBD = await companyService.getUsersCompanies(token)
      if (companiesBD && companiesBD.data && Number(companiesBD.statusCode) === 200) {
        let companies = companiesBD.data.map(company => ({
          id: company.company.id,
          companyName: company.company.companyName,
        }))
        companies = companies.sort((a, b) => a.companyName.toLowerCase().localeCompare(b.companyName.toLowerCase()));
        let noAssign = {
          companyName: t("signatureProfilesDetailsView.digitalVault.withoutAssign"),
          id: NIL_UUID
        }
        companies.unshift(noAssign)
        setCompanies(companies)
        // setCategories([{ id: 0, name: 'Sin asignar' }])
        // setSubCategories([{ items: [], subcategory: {} }])
        setIsLoading(false)
        toggleDialog();

      } else {
        setError(true);
        setTextError(t("signatureRequestProfileAction.error.companies"));
        setIsLoading(false);
        toggleDialog();
        setTimeout(() => {
          setError(false);
        }, 4000)
        return false
      }
    } catch (error) {
      setError(true);
      setTextError(t("signatureRequestProfileAction.error.companies"));
      setIsLoading(false);
      toggleDialog();
      setTimeout(() => {
        setError(false);
      }, 4000)
      return false
    }
  }

  const getTypeDocuments = async () => {
    try {
      let typeDocumentsBD = await categoryService.getTypeDocuments(token, 'Documento');
      if (typeDocumentsBD && typeDocumentsBD.data && Number(typeDocumentsBD.statusCode) === 200) {
        let typeDocuments = typeDocumentsBD.data;
        typeDocuments.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

        setAllTypeDocuments(typeDocuments)
      } else {
        setError(true);
        setTextError(t("signatureRequestProfileAction.error.typedocuments"));
        setIsLoading(false);
        setTimeout(() => {
          setError(false);
        }, 4000)
        return false
      }
    } catch (error) {
      setError(true);
      setTextError(t("signatureRequestProfileAction.error.typedocuments"));
      setIsLoading(false);
      setTimeout(() => {
        setError(false);
      }, 4000)
      return false
    }
  }


  const getCategories = async (companyId, setCategoryId, setSelect) => {
    if (companyId === NIL_UUID) {
      setCategories([{ id: 0, name: t("signatureProfilesDetailsView.digitalVault.withoutAssign") }])
      setSubCategories([{ items: [], subcategory: {} }])
      setCategoryId(0)
      setSelect([""])
      return
    }

    setIsLoading(true)

    try {
      let categoriesBD = await categoryService.getCategories(token, companyId);
      if (categoriesBD && categoriesBD.data && Number(categoriesBD.statusCode) === 200) {
        let categories = categoriesBD.data
        categories = categories.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
        let noAssign = { id: 0, name: t("signatureProfilesDetailsView.digitalVault.withoutAssign") }
        categories.unshift(noAssign)

        setCategories(categories)
        setSubCategories([{ items: [], subcategory: {} }])
        setCategoryId(0)
        setSelect([""])
        setIsLoading(false)
      } else {
        setError(true);
        setTextError(t("signatureRequestProfileAction.error.categories"));
        setIsLoading(false);
        setTimeout(() => {
          setError(false);
        }, 4000)
        return false
      }
    } catch (error) {
      setError(true);
      setTextError(t("signatureRequestProfileAction.error.categories"));
      setIsLoading(false);
      setTimeout(() => {
        setError(false);
      }, 4000)
      return false
    }
  }

  const getSubcategories = async (companyId, categoryId, setSelect) => {
    setSelect([""])
    if (companyId === NIL_UUID || categoryId === 0) {
      setSubCategories([{ items: [], subcategory: {} }])
      return
    }
    setIsLoading(true)

    try {
      let subCategoriesBD = await categoryService.getSubcategories(token, companyId, categoryId);
      if (subCategoriesBD && subCategoriesBD.data && Number(subCategoriesBD.statusCode) === 200) {
        let subCategories = subCategoriesBD.data
        subCategories = subCategories.sort((a, b) => a.subcategory.name.toLowerCase().localeCompare(b.subcategory.name.toLowerCase()));
        setSubCategories(subCategories)
        setIsLoading(false)
      } else {
        setError(true);
        setTextError(t("signatureRequestProfileAction.error.subcategories"));
        setIsLoading(false);
        setTimeout(() => {
          setError(false);
        }, 4000)
        return false
      }
    } catch (error) {
      setIsLoading(false);
      setError(true);
      setTextError(t("signatureRequestProfileAction.error.subcategories"));
      setTimeout(() => {
        setError(false);
      }, 4000)
      return false
    }
  }

  const onTreeExpandChange = (event) => {
    let ids = expand.ids.slice();
    const index = ids.indexOf(event.item.subcategory.id);
    index === -1 ? ids.push(event.item.subcategory.id) : ids.splice(index, 1);
    setExpand({
      ids,
      idField: "subcategory.id",
    });
  };

  const onChangeTree = (event) => {
    setSelect([event.itemHierarchicalIndex]);
    setShowErrorSub(false)
  }

  const getCategoriesPreloaded = async (companyId, categoryId) => {
    try {
      //GET categories
      let categoriesBD = await categoryService.getCategories(token, companyId);
      if (categoriesBD && categoriesBD.data && Number(categoriesBD.statusCode) === 200) {
        let newCategories = categoriesBD.data.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

        let noAssign = { id: 0, name: t("signatureProfilesDetailsView.digitalVault.withoutAssign") }
        newCategories.unshift(noAssign)

        setCategories(newCategories)
        if (categoryId) setCategoryId(categoryId)
      }

    } catch (error) {
      setError(true);
      setTextError(t("signatureRequestProfileAction.error.categories"));
      setIsLoading(false);
      setTimeout(() => {
        setError(false);
      }, 4000)
      return false
    }
  }

  const getSubcategoriesPreloaded = async (companyId, categoryId, pathBreadcrumb) => {
    let index = ''
    try {
      //GET subcategories
      let subCategoriesBD = await categoryService.getSubcategories(token, companyId, categoryId);
      if (subCategoriesBD && subCategoriesBD.data && Number(subCategoriesBD.statusCode) === 200) {
        let newSubCategories = subCategoriesBD.data.sort((a, b) => a.subcategory.name.toLowerCase().localeCompare(b.subcategory.name.toLowerCase()));
        if (pathBreadcrumb) {
          let idsExpand = []
          let pathSplit = pathBreadcrumb.split("/")
          if (pathSplit && pathSplit.length === 1) {
            index = newSubCategories.findIndex(sub => sub.subcategory.id === Number(pathBreadcrumb))
          }

          if (pathSplit && pathSplit.length === 2) {
            let subSplit = pathBreadcrumb.split('/')
            let catId = (subSplit) ? subSplit[0] : 0
            let subId = (subSplit) ? subSplit[1] : 0
            let catIndex = newSubCategories.findIndex(cat => cat.subcategory.id === Number(catId))
            let catFind = newSubCategories[catIndex]
            let subIndex = catFind.items.findIndex(sub => sub.subcategory.id === Number(subId))
            index = `${catIndex}_${subIndex}`
          }

          if (pathSplit && pathSplit.length === 3) {
            let subSplit = pathBreadcrumb.split('/')
            let catId = (subSplit) ? subSplit[0] : 0
            let subId = (subSplit) ? subSplit[1] : 0
            let subSubId = (subSplit) ? subSplit[2] : 0
            let catIndex = newSubCategories.findIndex(cat => cat.subcategory.id === Number(catId))
            let catFind = newSubCategories[catIndex]
            let subIndex = catFind.items.findIndex(sub => sub.subcategory.id === Number(subId))
            let subCat = catFind.items[subIndex]
            let subSubIndex = subCat.items.findIndex(sub => sub.subcategory.id === Number(subSubId))

            index = `${catIndex}_${subIndex}_${subSubIndex}`
          }

          pathSplit.map(indexPath => idsExpand.push(Number(indexPath)))
          index = (index !== -1) ? index : ''

          setSelect([`${index}`])
          setExpand(prev => ({
            ids: [...new Set([...prev.ids, ...idsExpand])],
            idField: "subcategory.id"
          }))
        }

        setSubCategories(newSubCategories)
      }
    } catch (error) {
      setIsLoading(false);
      setError(true);
      setTextError(t("signatureRequestProfileAction.error.subcategories"));
      setTimeout(() => {
        setError(false);
      }, 4000)
      return false
    }
  }

  return (
    <div className='standard-wrapper'>
      <div className="signatureProfileDetailView-container">
        <div className="signatureProfileDetailView-header">
          <HeaderHLPure title={t(id ? "signatureProfilesDetailsView.titleEdite" : "signatureProfilesDetailsView.titleCreate")} />
        </div>
        <div className="signatureProfileDetailView-body">
          <div className="signatureProfileDetailView-elements">
            {/* Data profile */}
            <InputHLPure
              inputActive
              labelInput={t("signatureProfilesDetailsView.name")}
              typeInput={"text"}
              valueInput={name}
              handleChangeInput={(e) => setName(e.target.value)}
              required
              tooltipShow
              informationIcon
              positionTooltip={isMobile ? "top" : "right"}
              titleTooltip={t(
                "signatureProfilesDetailsView.name"
              )}
              descriptionTooltip={t(
                "signatureProfilesDetailsView.nameTooltip"
              )}
            />
            <TextAreaHLPure
              labelTextArea={t(
                "signatureProfilesDetailsView.desription"
              )}
              valueTextData={description}
              handleChangeTextArea={(e) =>
                setDescription(e.target.value)
              }
              required
              tooltipShow
              informationIcon
              positionTooltip={isMobile ? "top" : "right"}
              titleTooltip={t(
                "signatureProfilesDetailsView.desription"
              )}
              descriptionTooltip={t(
                "signatureProfilesDetailsView.desriptionTooltip"
              )}
            />
            <div className="signatureProfileDetailView-grid-elements">
              <InputHLPure
                inputActive
                labelInput={t(
                  "signatureProfilesDetailsView.nameRequest"
                )}
                typeInput={"text"}
                valueInput={requestName}
                handleChangeInput={(e) =>
                  setRequestName(e.target.value)
                }
                tooltipShow
                informationIcon
                positionTooltip={isMobile ? "top" : "right"}
                titleTooltip={t(
                  "signatureProfilesDetailsView.nameRequest"
                )}
                descriptionTooltip={t(
                  "signatureProfilesDetailsView.nameRequestTooltip"
                )}
              />
              {isMobile ?
                <TextAreaHLPure
                  labelTextArea={t(
                    "signatureProfilesDetailsView.commet"
                  )}
                  valueTextData={comments}
                  handleChangeTextArea={(e) =>
                    setComments(e.target.value)
                  }
                  characterLimit={250}
                  tooltipShow
                  informationIcon
                  positionTooltip={isMobile ? "top" : "right"}
                  titleTooltip={t(
                    "signatureProfilesDetailsView.commet"
                  )}
                  descriptionTooltip={t(
                    "signatureProfilesDetailsView.commetTooltip"
                  )}
                />
                :
                <InputHLPure
                  inputActive
                  labelInput={t("signatureProfilesDetailsView.days")}
                  typeInput={"number"}
                  valueInput={days}
                  placeholder={"1"}
                  max={60}
                  min={1}
                  handleChangeInput={(e) =>
                    setDays(parseInt(e.target.value) || 0)
                  }
                  onBlur={(e) => {
                    const val = e.target.value;
                    if (val.trim() == "" || +val < 1) setDays(1);
                    if (+val > 60) setDays(60);
                  }}
                  tooltipShow
                  informationIcon
                  positionTooltip={isMobile ? "top" : "right"}
                  titleTooltip={t(
                    "signatureProfilesDetailsView.days"
                  )}
                  descriptionTooltip={t(
                    "signatureProfilesDetailsView.daysTooltip"
                  )}
                />

              }

              {!isMobile ?
                <TextAreaHLPure
                  labelTextArea={t(
                    "signatureProfilesDetailsView.commet"
                  )}
                  valueTextData={comments}
                  handleChangeTextArea={(e) =>
                    setComments(e.target.value)
                  }
                  characterLimit={250}
                  tooltipShow
                  informationIcon
                  positionTooltip={isMobile ? "top" : "right"}
                  titleTooltip={t(
                    "signatureProfilesDetailsView.commet"
                  )}
                  descriptionTooltip={t(
                    "signatureProfilesDetailsView.commetTooltip"
                  )}
                />
                :
                <InputHLPure
                  inputActive
                  labelInput={t("signatureProfilesDetailsView.days")}
                  typeInput={"number"}
                  valueInput={days}
                  placeholder={"1"}
                  max={60}
                  min={1}
                  handleChangeInput={(e) =>
                    setDays(parseInt(e.target.value) || 0)
                  }
                  onBlur={(e) => {
                    const val = e.target.value;
                    if (val.trim() == "" || +val < 1) setDays(1);
                    if (+val > 60) setDays(60);
                  }}
                  tooltipShow
                  informationIcon
                  positionTooltip={isMobile ? "top" : "right"}
                  titleTooltip={t(
                    "signatureProfilesDetailsView.days"
                  )}
                  descriptionTooltip={t(
                    "signatureProfilesDetailsView.daysTooltip"
                  )}
                />
              }
              <div>
                <DividerSubtitle
                  subtitle={t("signatureProfilesDetailsView.image")}
                  tooltipText={t("signatureProfilesDetailsView.image.tooltip")}
                  positionTooltip={isMobile ? "top" : "right"}
                />
                <button
                  className={`signatureProfilesDetails-rec rec-1 ${true && "disable-cursor"
                    }`}
                  onClick={toggleDialogIcon}
                >
                  {!image && <img src={PlusBlue} width={55} />}
                  {image && (
                    <img
                      className={`siganture-profile-img`}
                      src={image}
                    />
                  )}
                </button>
              </div>
            </div>
            <hr />
            {/* Services PSC */}
            <div>
              <DividerSubtitle
                subtitle={t(
                  "signatureProfilesDetailsView.serviciosTitle"
                )}
                tooltipText={t(
                  "signatureProfilesDetailsView.serviciosTitleTooltip"
                )}
                positionTooltip={isMobile ? "top" : "right"}
              />
              <div className="signatureProfileDetailView-checks">
                <CheckBoxHLPure
                  labelCheckBox={t(
                    "signatureProfilesDetailsView.messagePreservation"
                  )}
                  checkedState={serviceConservationMessage}
                  onChangeHandler={(e) =>
                    handleSelectPSC(e, t("signatureProfilesDetailsView.messagePreservation"))
                  }
                />
              </div>
            </div>
            {/* Signature Type */}
            <div>
              <DividerSubtitle
                subtitle={`${t(
                  "signatureProfilesDetailsView.typeTitle"
                )} *`}
                tooltipText={t(
                  "signatureProfilesDetailsView.typeTitleTooltip"
                )}
                positionTooltip={isMobile ? "top" : "right"}
              />
              <div className="signatureProfileDetailView-checks">
                <CheckBoxHLPure
                  labelCheckBox={t(
                    "signatureProfilesDetailsView.e.signature"
                  )}
                  checkedState={signatureTypeESign}
                  onChangeHandler={(e) =>
                    setsignatureTypeESign(e.target.checked)
                  }
                />
                <CheckBoxHLPure
                  labelCheckBox={t(
                    "signatureProfilesDetailsView.electronicSignature"
                  )}
                  checkedState={signatureTypeAdvance}
                  onChangeHandler={(e) =>
                    setsignatureTypeAdvance(e.target.checked)
                  }
                />
                <div className="signatureProfilesDetails-govoauth">
                  <CheckBoxHLPure
                    labelCheckBox={t(
                      "signatureProfilesDetailsView.autograph"
                    )}
                    checkedState={signatureTypeAutograph}
                    onChangeHandler={(e) => handleChangeAutographCheck(e)}
                  />
                  {
                    signatureTypeAutograph && (
                      <div className="signatureProfileDetailView-proofOflife">
                        <CheckBoxHLPure
                          labelCheckBox={t("signatureProfilesView.biometric.validation")}
                          checkedState={proofOfLifeChecked}
                          onChangeHandler={(e) => handleChangeBiometric(e, "proofOfLife")}
                        />
                      </div>
                    )
                  }
                </div>
              </div>
            </div>
            {/* Order */}
            <div>
              <DividerSubtitle
                subtitle={`${t(
                  "signatureProfilesDetailsView.orderTitle"
                )} *`}
                tooltipText={t(
                  "signatureProfilesDetailsView.orderTitleTooltip"
                )}
                positionTooltip={isMobile ? "top" : "right"}
              />
              <div className="signatureProfileDetailView-checks">
                <CheckBoxHLPure
                  labelCheckBox={t(
                    "signatureProfilesDetailsView.random"
                  )}
                  checkedState={processRandom}
                  onChangeHandler={(e) =>
                    setprocessRandom(e.target.checked)
                  }
                />
                <CheckBoxHLPure
                  labelCheckBox={t(
                    "signatureProfilesDetailsView.sequential"
                  )}
                  checkedState={processSequential}
                  onChangeHandler={(e) =>
                    setprocessSequential(e.target.checked)
                  }
                />
                <CheckBoxHLPure
                  labelCheckBox={t(
                    "signatureProfilesDetailsView.approvingly"
                  )}
                  checkedState={processAprovation}
                  onChangeHandler={(e) =>
                    setprocessAprovation(e.target.checked)
                  }
                />
                <CheckBoxHLPure
                  labelCheckBox={t(
                    "signatureProfilesDetailsView.approval"
                  )}
                  checkedState={processAprovationSequential}
                  onChangeHandler={(e) =>
                    setprocessAprovationSequential(e.target.checked)
                  }
                />
              </div>
            </div>
            <hr />
            {/* Document profiles */}
            <div>
              <DividerSubtitle
                subtitle={t("signatureProfilesDetailsView.document.profile")}
                tooltipText={t(
                  "signatureProfilesDetailsView.typeTitleTooltip"
                )}
                positionTooltip={isMobile ? "top" : "right"}
              />
              <div className="signatureProfileDetailView-checks-document-profile">
                {documentProfile.documentProfile.length > 0 &&
                  documentProfile.documentProfile.map(
                    (item, index) => (
                      <CheckBoxHLPure
                        labelCheckBox={item.documentName}
                        checkedState={item.checked}
                        onChangeHandler={(e) =>
                          onChangeUserDocumentProfile(
                            e.target.checked,
                            index
                          )
                        }
                      />
                    )
                  )}
              </div>
            </div>
            <hr />
            {/* Assign categories */}
            <div className="signatureProfilesDetails-container-assign-categories">
              <div className="signatureRequestCategoriesView-subtitle">
                <p className="signatureRequestCategoriesView-label-title">{t("assign.categories.title")}</p>
              </div>
              <div>
                <DropDownBtnHLPure
                  labelDropDown={t("questionnairesAssignCategories.company")}
                  optionsDropDown={companies}
                  optionsValue={companyId}
                  valueItem={"id"}
                  nameOption={"companyName"}
                  onDropDownChange={(e) => handleChange(e, setCompanyId, null, setShowErrorCompany, 'company')}
                  required
                />
                {
                  showErrorCompany &&
                  <p className='hint-message-error'>{`${t("questionnairesAssignCategories.company.error")}`}</p>
                }
              </div>
              <div>
                <DropDownBtnHLPure
                  labelDropDown={t("questionnairesAssignCategories.category")}
                  optionsDropDown={categories}
                  optionsValue={categoryId}
                  valueItem={"id"}
                  nameOption={"name"}
                  onDropDownChange={(e) => handleChange(e, setCategoryId, 'Number', setShowErrorCategories, 'category')}
                  required
                />
                {
                  showErrorCategories &&
                  <p className='hint-message-error'>{`${t("questionnairesAssignCategories.category.error")}`}</p>
                }
              </div>
              <div className="signatureRequestCategoriesView-subcategory">
                <p className="questionnairesAssignCategories-inputHLPure-label">{`${t("questionnairesAssignCategories.subcategory")}`}</p>
                {subCategories && subCategories.length > 0 && subCategories[0].subcategory && subCategories[0].subcategory.id
                  ? <TreeView
                    data={processTreeViewItems(subCategories, {
                      select: select,
                      expand: expand,
                    })}
                    expandIcons
                    size={"medium"}
                    textField='subcategory.name'
                    onExpandChange={onTreeExpandChange}
                    onItemClick={(e) => onChangeTree(e)}
                  />
                  : <p className='questionnairesAssignCategories-not-assigned'>{`${t("questionnairesAssignCategories.no.assign")}`}</p>
                }
                {
                  showErrorSub &&
                  <p className='hint-message-error'>{`t("questionnairesAssignCategories.subcategory.error)`}</p>
                }

              </div>
              <div className="signatureRequestCategoriesView-type-document">
                <ComboBoxTemplatePure
                  title={t("questionnairesAssignCategories.type.document")}
                  placeholder={t("questionnairesAssignCategories.select.type.document")}
                  allowCustom={false}
                  data={typeDocuments}
                  textField="name"
                  dataItemKey="id"
                  value={typeDocument}
                  onChange={(e) => {
                    const v = e.target.value
                    handleChange({ target: { value: v && typeof v === 'object' ? v : '' } }, setTypeDocument, null, setShowTypeDoc)
                  }}
                  required
                  validityStyles={false}
                  errorCombobox={showErrorComboBox}
                  errorMessage={t("questionnairesAssignCategories.error.type.document")}
                />
                {
                  showErrorTypeDoc &&
                  <p className='hint-message-error'>{t("questionnairesAssignCategories.error.type.document")}</p>
                }
              </div>
            </div>
            <div className="signatureProfilesDetails-btn-container">
              <ButtonHLPure
                nameBtn={t("signatureProfilesDetailsView.back")}
                onClickBtn={() => history.push("/signature-profile")}
              />
              {
                showBtnSave && (
                  <ButtonHLPure
                    primary
                    nameBtn={t("signatureProfilesDetailsView.save")}
                    onClickBtn={fetch}
                  />
                )
              }
            </div>
          </div>
        </div>
        <div className="signatureProfileDetailView-footer">
          <PromotionalFooterPure />
        </div>
        {showDialogIcon && (
          <DialogTemplatePure
            cancel={onCancelIcon}
            title={t("signatureProfilesDetailsView.modal.title")}
            description={t("signatureProfilesDetailsView.modal.instructions")}
            canelBtn={t("button.cancel")}
            saveBtn={t("button.save")}
            handleSubmitProfile={(event) => onSaveImg(event)}
            loadingComponent={isLoading}
          >
            <div
              className="signatureProfilesDetailsView-container-gallery"
              xs={12}
            >
              {icons.map((item, index) => (
                <div className="signatureProfilesDetailsView-container-icons">
                  <RadioButton
                    className="signatureProfilesDetailsView-radioBtn-img"
                    name="icon"
                    value={item.path}
                    checked={image === item.path}
                    onChange={({ value }) => setImage(value)}
                  />
                  <img
                    src={item.path}
                    {...item}
                    className="icon-style"
                    key={index}
                  />
                </div>
              ))}
            </div>
          </DialogTemplatePure>
        )}

        {showDialog && (
          <DialogSystemGLPure
            showLoadingRequesting={isLoading}
            toggleLoadingRequesting={() => setIsLoading((prev) => !prev)}
            showCompletedRequesting={success}
            toggleCompletedRequesting={() => setSuccess((prev) => !prev)}
            showErrorRequesting={error}
            toggleErrorRequesting={() => setError((prev) => !prev)}
            messageError={textError}
          />
        )}
      </div>
    </div >
  );
}
